// tslint:disable-next-line:max-line-length
import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
// tslint:disable-next-line:max-line-length
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  FormGroupDirective,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import * as cloneDeep from 'lodash/cloneDeep';
import { combineLatest } from 'rxjs';
import {
  LoadFormDataModel,
  LoadInletModel,
  LoadInletSensingModel,
  LoadParameterModel
} from 'src/app/models/index';
import {
  CommonService,
  PlantServiceService,
  SiteService,
  SiteStepperService
} from 'src/app/services/index';
import { AlertService, AppUtils, Constants } from 'src/app/shared';
import * as ObjectUtils from 'util';
export const inputInletNameUniqueValidator: ValidatorFn =
  (): ValidationErrors | null => {
    return { inputInletNameUniqueValidator: true };
  };
export const inputOutletNameUniqueValidator: ValidatorFn =
  (): ValidationErrors | null => {
    return { inputOutletNameUniqueValidator: true };
  };
export const inputInletIDUniqueValidator: ValidatorFn =
  (): ValidationErrors | null => {
    return { inputInletIDUniqueValidator: true };
  };
export const inputOutletIDUniqueValidator: ValidatorFn =
  (): ValidationErrors | null => {
    return { inputOutletIDUniqueValidator: true };
  };
export const lessThanInletValidator: ValidatorFn =
  (): ValidationErrors | null => {
    return { lessThanInletInvalid: true };
  };
export const isInletLowerThresholdValid: ValidatorFn =
  (): ValidationErrors | null => {
    return { isInletLowerThresholdValid: true };
  };
export const isInletUpperThresholdValid: ValidatorFn =
  (): ValidationErrors | null => {
    return { isInletUpperThresholdValid: true };
  };
export const isOutletLowerThresholdValid: ValidatorFn =
  (): ValidationErrors | null => {
    return { isOutletLowerThresholdValid: true };
  };
export const isOutLetUpperThresholdValid: ValidatorFn =
  (): ValidationErrors | null => {
    return { isOutLetUpperThresholdValid: true };
  };

@Component({
  selector: 'app-add-load',
  templateUrl: './add-load.component.html',
  styleUrls: ['./add-load.component.scss']
})
export class AddLoadComponent
  implements OnInit, AfterViewInit, AfterViewChecked
{
  @ViewChild('formDirective') formDirective: FormGroupDirective;
  formMasterGroup: FormGroup;
  formStratificationTank: FormGroup;
  model: any;
  tempModel: any;
  load: any;
  sites: any;
  availableMeters: any;
  editLoad = false;
  loadTypes = [];
  loadSubTypes = [];
  subTypes = {};
  consLoadTypeObj = Constants.LOAD_TYPE;
  consLoadTypeKeys = Object.keys(this.consLoadTypeObj);
  kpiUtility: string;
  configuredKpiUtilities: string[];
  //
  paramsAll = false;
  params = [
    {
      value: Constants.LOAD_PARAM.ALL_ELECTRICAL,
      text: 'All Electrical Parameters'
    },
    { value: Constants.LOAD_PARAM.TEMPERATURE, text: 'Temperature' },
    { value: Constants.LOAD_PARAM.PRESSURE, text: 'Pressure' },
    { value: Constants.LOAD_PARAM.FLOW_OUTPUT, text: 'Flow Output' }
  ];
  showParamErrorLabel = true;
  temperatureUnits = ['Celsius', 'Fahrenheit', 'Kelvin'];
  pressureUnits = [
    'Pascal (Pa)',
    'Bar (bar)',
    'Std Atmosphere (atm)',
    'Torr (torr)',
    'PSI (psi)'
  ];
  paramOther: any;
  touValue = false;
  items = [
    { name: 'First Item', value: 1 },
    { name: 'Second Item', value: 10 },
    { name: 'Third Item', value: 100 }
  ];
  formData: LoadFormDataModel;
  hydraulicParameterType = Object.values(Constants.HYDRAULIC_PARAMETER_TYPE);
  hydraulicOutputType = [];
  digitalOutputMapping: any;
  requiredValidators = [Validators.required];
  // Checking duplicated Load name
  availableLoadName: any;
  isSiteSelected: boolean;
  isDuplicatedLoadName: boolean;
  isDuplicatedMachineId: boolean;
  availableMachineId: any;
  //
  /** Optional parameter to hide the close icon on the right top corner */
  @Input() closeIcon = true;
  /** Optional close handler to intercept close mechanism */
  @Output() closeHandler: EventEmitter<any> = new EventEmitter();
  input_loadId: string;
  input_siteId: string;
  createNew = true;
  title = 'Add New Load';
  old_inlets: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private siteService: SiteService,
    private commonService: CommonService,
    private cdRef: ChangeDetectorRef,
    private alertService: AlertService,
    private fb: FormBuilder,
    private siteStepperService: SiteStepperService,
    private plantService: PlantServiceService
  ) {
    this.formMasterGroup = this.fb.group({
      siteNameCtr: ['', [Validators.required]],
      kpiUtilityCtr: ['', [Validators.required]],
      meterCtr: [''],
      loadNameCtr: ['', [Validators.required]],
      kwRatingCtr: ['', [Validators.required]],
      loadTypeCtr: ['', [Validators.required]],
      kwThresholdCtr: [''],
      kvaRatingCtr: [''],
      subTypeCtr: [''],
      phasetypeCtr: [''],
      makeCtr: ['', [Validators.required, Validators.minLength(4)]],
      parameterCtr_0: [''],
      parameterCtr_1: [''],
      parameterCtr_2: [''],
      parameterCtr_3: [''],
      parameterCtr_4: [''],
      parameterCtr_5: [''],
      parameterCtr_6: [''],
      parameterCtr_7: [''],
      parameterCtr_8: [''],
      parameterCtr_9: [''],
      paramOtherNameCtr: [''],
      paramOtherUnitCtr: [''],
      //
      inputNoCtr: [''],
      inputNoSensorCtr: [''],
      inputNoHydraulicCtr: [''],
      outputNoCtr: [''],
      outputNoHydraulicCtr: [''],
      thermoclinesCtr: [''],
      inletItems: this.fb.array([]),
      outletItems: this.fb.array([]),
      hardwareVersionCtr: [''],
      machineIDCtr: [''],
      machineIDHydraulicCtr: [''],
      inletSensingItems: this.fb.array([]),
      outletSensingItems: this.fb.array([]),
      inletHydraulicItems: this.fb.array([]),
      outletHydraulicItems: this.fb.array([]),
      //
      inputConstraintCtr: [''],
      outputConstraintCtr: [''],
      idealPowerConsumptionCtr: ['', [Validators.required]],
      maintenancewindowCtr: ['', [Validators.required]],
      drflexibilityCtr: [''],
      commentCtr: ['', [Validators.maxLength(200)]]
    });
    this.model = {};
    this.tempModel = {};
    this.load = {};
    this.paramOther = {};
    // this.initObject();
    this.formData = new LoadFormDataModel();
    this.siteService.getAllSites().subscribe((sites) => {
      this.sites = sites;
      this.prepareForEditLoad();
    });
    // const consLoadTypeObj = Constants.LOAD_TYPE;
    // const consLoadTypeKeys = Object.keys(consLoadTypeObj);
    for (let i = 0; i < this.consLoadTypeKeys.length; i++) {
      const temp = this.consLoadTypeObj[this.consLoadTypeKeys[i]]['TYPE_VALUE'];
      if (temp === 'GenericSensorLoad') {
        this.loadTypes.push('Generic / Area Specific Sensor');
      } else {
        this.loadTypes.push(temp);
      }
    }
    const tempType = Object.keys(Constants.HYDRAULIC_OUTPUT_TYPE);
    for (let i = 0; i < tempType.length; i++) {
      const temp = Constants.HYDRAULIC_OUTPUT_TYPE[tempType[i]];
      this.hydraulicOutputType.push({ value: tempType[i], text: temp });
    }
    this.availableLoadName = [];
    this.availableMachineId = [];
  }
  private initObject = () => {
    this.load.parameters = this.params.map(
      (x) => new LoadParameterModel(x.text, x.value, '', false)
    );
    this.paramOther.name = '';
    this.paramOther.checked = false;
    this.paramOther.unit = '';
    this.setEnableDisableFlowOutputParameter(3); // FlowOutput
  };
  ngOnInit() {
    const urlParams = combineLatest(
      this.activeRoute.params,
      this.activeRoute.queryParams,
      (params, queryParams) => ({ ...params, ...queryParams })
    );

    // Subscribe to the single observable, giving us both
    urlParams.subscribe((routeParams) => {
      this.input_loadId = routeParams.loadId;
      this.input_siteId = routeParams.siteId;
    });
    const model = {}; // Check later
    this.siteService.getDigitalOutputMapping(model).subscribe((data) => {
      this.digitalOutputMapping = data;
    });
  }
  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }
  prepareForEditLoad() {
    if (this.input_loadId !== undefined && this.input_loadId !== '') {
      this.createNew = false;
      this.commonService.selectedSiteInLoadInventory = this.input_siteId;
      this.load.siteID = this.input_siteId;
      this.title = 'Edit Load';
      this.siteService
        .getLoadDetail(this.input_siteId, this.input_loadId)
        .subscribe((data) => {
          this.load = data;
          if (data.meter) {
            this.editLoad = true;
            if (this.commonService.isNullOrUndefined(data.meter.meterId)) {
              this.load.meter.meterId = ' ';
            }
          }
          if (
            this.commonService.isNullOrUndefined(this.load.siteID) ||
            this.load.siteID === ''
          ) {
            this.load.siteID = this.input_siteId;
          }
          this.formMasterGroup.get('siteNameCtr').disable();
          this.formMasterGroup.get('kpiUtilityCtr').disable();
          this.formMasterGroup.get('meterCtr').disable();
          if (this.load.type === 'GenericSensorLoad') {
            this.load.type = 'Generic / Area Specific Sensor';
          }
          let totalForCheckAll = this.load.parameters.length;
          const parametersTemp = this.params.map(
            (x) => new LoadParameterModel(x.text, x.value, '', false)
          );

          for (let i = 0; i < parametersTemp.length; i++) {
            const find = this.load.parameters.find(
              (item) => item.name === parametersTemp[i].value
            );
            if (!this.commonService.isNullOrUndefined(find)) {
              // parametersTemp[i] = find;
              parametersTemp[i].selected = true;
            } else {
              parametersTemp[i].selected = false;
            }
          }
          const otherParam = this.load.parameters.find(
            (item) => item.other === true
          );
          if (!this.commonService.isNullOrUndefined(otherParam)) {
            this.paramOther.checked = true;
            this.paramOther.name = otherParam.name;
            this.paramOther.unit = otherParam.unit;
            totalForCheckAll--;
          }
          if (totalForCheckAll === 4) {
            this.paramsAll = true;
          }
          this.load.parameters = parametersTemp;
          // this.showAndHideParamErrorLabel();
          if (!this.commonService.isNullOrUndefined(data.inlets)) {
            this.formData.inputNo = data.inlets.length;
            this.formData.inlets = data.inlets;
          }
          if (!this.commonService.isNullOrUndefined(data.outlets)) {
            this.formData.outputNo = data.outlets.length;
            this.formData.outlets = data.outlets;
          }
          this.cdRef.detectChanges();
        });
    } else {
      this.initObject();
    }
  }
  public changeLoadType = () => {
    this.removeMeterCtr();
    if (this.subTypes[this.load.type] === undefined) {
      if (this.load.type !== undefined) {
        let type: string;
        if (this.load.type === 'Generic / Area Specific Sensor') {
          type = 'GenericSensorLoad';
        } else {
          type = this.load.type;
        }
        this.siteService.getLoadSubType(type).subscribe((data) => {
          const subTypesData = [];
          const loadTypeKey = this.getLoadTypeKeyByValue(data.type);
          if (loadTypeKey === undefined) {
            for (let i = 0; i < data.length; i++) {
              subTypesData.push({ text: data[i], value: data[i] });
            }
          } else {
            const subTypesValueText =
              this.consLoadTypeObj[loadTypeKey]['SUB_TYPES_VALUE_TEXT'];
            if (subTypesValueText === undefined) {
              for (let i = 0; i < data.length; i++) {
                subTypesData.push({ text: data[i], value: data[i] });
              }
            } else {
              for (let i = 0; i < data.length; i++) {
                const text = subTypesValueText[data[i]];
                if (text !== undefined) {
                  subTypesData.push({ text: text, value: data[i] });
                } else {
                  subTypesData.push({ text: data[i], value: data[i] });
                }
              }
            }
          }
          this.loadSubTypes = subTypesData;
          this.subTypes[this.load.type] = subTypesData;
        });
      }
    } else {
      this.loadSubTypes = this.subTypes[this.load.type];
    }
    this.removeAllValidatorCtr();
    switch (this.load.type) {
      case 'Transformer': {
        const kwThresholdCtr = this.formMasterGroup.get('kwThresholdCtr');
        const kvaRatingCtr = this.formMasterGroup.get('kvaRatingCtr');
        kwThresholdCtr.setValidators(this.requiredValidators);
        kvaRatingCtr.setValidators(this.requiredValidators);
        kwThresholdCtr.updateValueAndValidity();
        kvaRatingCtr.updateValueAndValidity();
        break;
      }
      case 'Generic / Area Specific Sensor': {
        this.setGenericSensorCtr();
        break;
      }
      default: {
        break;
      }
    }
  };
  public changeSubLoadType = () => {
    this.removeAllValidatorCtr();
    this.setNullValueHasEnergyMeter();
    this.removeMeterCtr();
    switch (this.load.subType) {
      case 'StratificationTank': {
        this.setStratificationTankCtr();
        break;
      }
      case 'Hydraulic Unit': {
        this.setMeterCtr();
        if (this.load.type === 'Turning') {
          this.setTurningCtr();
        }
        break;
      }
      case 'Generic Load': {
        // if (this.load.type === 'Generic / Area Specific Sensor') {
        //   this.setGenericSensorCtr();
        // }
        this.setGenericSensorCtr();
        break;
      }
      default: {
        break;
      }
    }
  };
  private removeAllValidatorCtr = () => {
    //
    const kvaRatingCtr = this.formMasterGroup.get('kvaRatingCtr');
    const kwThresholdCtr = this.formMasterGroup.get('kwThresholdCtr');
    kvaRatingCtr.setValidators(null);
    kwThresholdCtr.setValidators(null);
    kvaRatingCtr.updateValueAndValidity();
    kwThresholdCtr.updateValueAndValidity();
    //
    if (this.load.inlets !== undefined) {
      this.load.inlets = [];
    }
    if (this.load.outlets !== undefined) {
      this.load.outlets = [];
    }
    // StratificationTank info
    const inputNoCtr = this.formMasterGroup.get('inputNoCtr');
    const outputNoCtr = this.formMasterGroup.get('outputNoCtr');
    const thermoclinesCtr = this.formMasterGroup.get('thermoclinesCtr');
    let inletItems = this.formMasterGroup.get('inletItems') as FormArray;
    let outletItems = this.formMasterGroup.get('outletItems') as FormArray;
    inputNoCtr.setValue(null);
    outputNoCtr.setValue(null);
    inputNoCtr.setValidators(null);
    outputNoCtr.setValidators(null);
    thermoclinesCtr.setValidators(null);
    inletItems = this.fb.array([]);
    outletItems = this.fb.array([]);
    inletItems.clearValidators();
    outletItems.clearValidators();
    inputNoCtr.updateValueAndValidity();
    outputNoCtr.updateValueAndValidity();
    thermoclinesCtr.updateValueAndValidity();
    inletItems.updateValueAndValidity();
    outletItems.updateValueAndValidity();
    // Generic
    const inputNoSensorCtr = this.formMasterGroup.get('inputNoSensorCtr');
    const machineIDCtr = this.formMasterGroup.get('machineIDCtr');
    let inletSensingItems = this.formMasterGroup.get(
      'inletSensingItems'
    ) as FormArray;
    inputNoSensorCtr.setValue(null);
    inputNoSensorCtr.setValidators(null);
    machineIDCtr.setValidators(null);
    inletSensingItems = this.fb.array([]);
    inletSensingItems.clearValidators();
    inputNoSensorCtr.updateValueAndValidity();
    machineIDCtr.updateValueAndValidity();
    inletSensingItems.updateValueAndValidity();
    // Hydraulic
    const inputNoHydraulicCtr = this.formMasterGroup.get('inputNoHydraulicCtr');
    const outputNoHydraulicCtr = this.formMasterGroup.get(
      'outputNoHydraulicCtr'
    );
    const machineIDHydraulicCtr = this.formMasterGroup.get(
      'machineIDHydraulicCtr'
    );
    let inletHydraulicItems = this.formMasterGroup.get(
      'inletHydraulicItems'
    ) as FormArray;
    let outletHydraulicItems = this.formMasterGroup.get(
      'outletHydraulicItems'
    ) as FormArray;
    inputNoHydraulicCtr.setValue(null);
    outputNoHydraulicCtr.setValue(null);
    inputNoHydraulicCtr.setValidators(null);
    outputNoHydraulicCtr.setValidators(null);
    machineIDHydraulicCtr.setValidators(null);
    inletHydraulicItems = this.fb.array([]);
    outletHydraulicItems = this.fb.array([]);
    inletHydraulicItems.clearValidators();
    outletHydraulicItems.clearValidators();
    inputNoHydraulicCtr.updateValueAndValidity();
    outputNoHydraulicCtr.updateValueAndValidity();
    machineIDHydraulicCtr.updateValueAndValidity();
    inletHydraulicItems.updateValueAndValidity();
    outletHydraulicItems.updateValueAndValidity();
  };
  private setStratificationTankCtr = () => {
    const inputNoCtr = this.formMasterGroup.get('inputNoCtr');
    const outputNoCtr = this.formMasterGroup.get('outputNoCtr');
    const thermoclinesCtr = this.formMasterGroup.get('thermoclinesCtr');
    const inOutValidator = [
      Validators.required,
      Validators.min(1),
      Validators.max(10)
    ];
    inputNoCtr.setValidators(inOutValidator);
    outputNoCtr.setValidators(inOutValidator);
    inputNoCtr.setValue(null);
    outputNoCtr.setValue(null);
    thermoclinesCtr.setValidators(this.requiredValidators);
    inputNoCtr.updateValueAndValidity();
    outputNoCtr.updateValueAndValidity();
    thermoclinesCtr.updateValueAndValidity();
  };
  private setNullValueHasEnergyMeter = () => {
    if (this.load.hasEnergyMeter !== undefined) {
      this.load.hasEnergyMeter = undefined;
    }
  };
  private removeMeterCtr = () => {
    const meterCtr = this.formMasterGroup.get('meterCtr');
    if (this.createNew) {
      meterCtr.enable();
    }
    meterCtr.setValidators(null);
    if (this.load.hasEnergyMeter !== 'NO') {
      meterCtr.setValidators(this.requiredValidators);
    }
    meterCtr.updateValueAndValidity();
  };
  private setMeterCtr = () => {
    const meterCtr = this.formMasterGroup.get('meterCtr');
    if (
      this.load.hasEnergyMeter === 'NO' &&
      this.load.subType === 'Hydraulic Unit'
    ) {
      meterCtr.setValidators(null);
      meterCtr.setValue(null);
      meterCtr.disable();
    }
    meterCtr.updateValueAndValidity();
  };
  private setTurningCtr = () => {
    const inputNoHydraulicCtr = this.formMasterGroup.get('inputNoHydraulicCtr');
    const outputNoHydraulicCtr = this.formMasterGroup.get(
      'outputNoHydraulicCtr'
    );
    const machineIDHydraulicCtr = this.formMasterGroup.get(
      'machineIDHydraulicCtr'
    );
    const inOutValidator = [
      Validators.required,
      Validators.min(1),
      Validators.max(30)
    ];
    inputNoHydraulicCtr.setValue(null);
    inputNoHydraulicCtr.setValidators(inOutValidator);
    outputNoHydraulicCtr.setValue(null);
    outputNoHydraulicCtr.setValidators(inOutValidator);
    if (this.load.hasEnergyMeter === 'NO') {
      machineIDHydraulicCtr.setValidators(this.requiredValidators);
      machineIDHydraulicCtr.updateValueAndValidity();
    }
    inputNoHydraulicCtr.updateValueAndValidity();
    outputNoHydraulicCtr.updateValueAndValidity();
    machineIDHydraulicCtr.updateValueAndValidity();
  };
  private setGenericSensorCtr = () => {
    const inputNoSensorCtr = this.formMasterGroup.get('inputNoSensorCtr');
    const machineIDCtr = this.formMasterGroup.get('machineIDCtr');
    const inOutValidator = [
      Validators.required,
      Validators.min(1),
      Validators.max(30)
    ];
    inputNoSensorCtr.setValidators(inOutValidator);
    if (this.load.hasEnergyMeter === 'NO') {
      machineIDCtr.setValidators(this.requiredValidators);
      machineIDCtr.updateValueAndValidity();
    }
    inputNoSensorCtr.setValue(null);
    inputNoSensorCtr.updateValueAndValidity();
    machineIDCtr.updateValueAndValidity();
  };
  private createInletsItems = (): FormGroup => {
    return this.fb.group({
      inputNameCtr: [
        '',
        [Validators.required, Validators.minLength(1), Validators.maxLength(15)]
      ],
      inputIDCtr: ['', [Validators.required]],
      inputInsiteIDCtr: ['', [Validators.required]],
      inletDiameterCtr: ['', [Validators.required]],
      inletMFRCtr: ['', [Validators.required]],
      inletThresholdTempCtr: ['', [Validators.required]],
      inletUpperThresholdTempCtr: ['', [Validators.required]],
      valveSwitchPresentCtr: ['']
    });
  };
  private createInletsSenssingItems = (): FormGroup => {
    return this.fb.group({
      inputNameCtr: [
        '',
        [Validators.required, Validators.minLength(1), Validators.maxLength(15)]
      ],
      inputIDCtr: [
        '',
        [Validators.required, Validators.minLength(1), Validators.maxLength(60)]
      ],
      ioChannnelSerialNumberCtr: ['', [Validators.required]],
      parameterTypeCtr: ['', [Validators.required]],
      parameterTypeDisplayValueCtr: [
        '',
        [Validators.required, Validators.minLength(2), Validators.maxLength(30)]
      ],
      outputTypeCtr: ['', [Validators.required]],
      digitalOutputMappingCtr: [''],
      sensorPartNumberCtr: ['', [Validators.required]],
      inletThresholdTempCtr: ['', [Validators.required]],
      inletUpperThresholdTempCtr: ['', [Validators.required]]
    });
  };
  private createInletsHydraulicItems = (): FormGroup => {
    return this.fb.group({
      inputNameCtr: [
        '',
        [Validators.required, Validators.minLength(3), Validators.maxLength(30)]
      ],
      inputIDCtr: [
        '',
        [Validators.required, Validators.minLength(1), Validators.maxLength(60)]
      ],
      ioChannnelSerialNumberCtr: ['', [Validators.required]],
      parameterTypeCtr: ['', [Validators.required]],
      parameterTypeDisplayValueCtr: [
        '',
        [Validators.required, Validators.minLength(2), Validators.maxLength(30)]
      ],
      outputTypeCtr: ['', [Validators.required]],
      digitalOutputMappingCtr: [''],
      sensorPartNumberCtr: ['', [Validators.required]],
      inletThresholdTempCtr: ['', [Validators.required]],
      inletUpperThresholdTempCtr: ['', [Validators.required]]
    });
  };
  private getLoadTypeKeyByValue = (value: any) => {
    for (let i = 0; i < this.consLoadTypeKeys.length; i++) {
      if (
        this.consLoadTypeObj[this.consLoadTypeKeys[i]]['TYPE_VALUE'] === value
      ) {
        return this.consLoadTypeKeys[i];
      }
    }
    return undefined;
  };
  public checkAllParams = () => {
    // this.load.parameters = [];
    // if (this.paramsAll) {

    //   for (let i = 0; i < this.params.length; i++) {
    //     this.load.parameters.push({name: this.params[i].value});
    //   }
    // }
    for (let i = 0; i < this.load.parameters.length; i++) {
      this.load.parameters[i].selected = this.paramsAll;
      this.setParameterValidator(i);
    }
    this.setEnableDisableFlowOutputParameter(3);
  };
  public changeChkBoxParam = (index: number) => {
    // if (index !== undefined) {
    //   if (this.load.parameters[index].name === '') {
    //     this.load.parameters[index] = undefined;
    //     this.paramsAll = false;
    //   }
    // }
    // const selectedParams = [];
    // for (let i = 0; i < this.load.parameters.length; i++) {
    //   if (this.load.parameters[i] !== undefined) {
    //     if (this.load.parameters[i].name !== '') {
    //       selectedParams.push(this.load.parameters[i].name);
    //     } else {
    //       this.load.parameters[i].unit = '';
    //     }
    //   }
    // }
    // if (selectedParams.length === this.params.length) {
    //   this.paramsAll = true;
    // } else {
    //   this.paramsAll = false;
    // }
    // this.showAndHideParamErrorLabel();
    this.setEnableDisableFlowOutputParameter(index);
    this.setParameterValidator(index);
    if (index !== undefined) {
      if (this.load.parameters[index].value === 'flowOutput') {
        if (this.load.parameters[index].selected) {
          this.formMasterGroup.get('parameterCtr_' + index).enable();
        } else {
          this.formMasterGroup.get('parameterCtr_' + index).disable();
        }
      }
    }
    this.paramsAll = this.load.parameters.every(function (item: any) {
      return item.selected === true;
    });
  };
  private setEnableDisableFlowOutputParameter = (index: number) => {
    if (index !== undefined) {
      if (this.load.parameters[index].value === 'flowOutput') {
        if (this.load.parameters[index].selected) {
          this.formMasterGroup.get('parameterCtr_' + index).enable();
        } else {
          this.formMasterGroup.get('parameterCtr_' + index).disable();
        }
      }
    }
  };
  private setParameterValidator = (index: number) => {
    if (
      index > 0 &&
      (this.load.parameters[index].name === Constants.LOAD_PARAM.ALL_HARMONIC ||
        this.load.parameters[index].name === Constants.LOAD_PARAM.ALL_WATER)
    ) {
      // skip first
      const parameter = this.load.parameters[index];
      const parameterCtr = this.formMasterGroup.get('parameterCtr_' + index);
      if (parameter.selected) {
        parameterCtr.setValidators(this.requiredValidators);
      } else {
        parameterCtr.setValidators(null);
      }
      parameterCtr.updateValueAndValidity();
    }
  };
  public changeChkBoxParamOther = () => {
    const paramOtherNameCtr = this.formMasterGroup.get('paramOtherNameCtr');
    const paramOtherUnitCtr = this.formMasterGroup.get('paramOtherUnitCtr');
    if (this.paramOther.checked) {
      paramOtherNameCtr.setValidators(this.requiredValidators);
      paramOtherUnitCtr.setValidators(this.requiredValidators);
    } else {
      this.paramOther.name = '';
      this.paramOther.unit = '';
      paramOtherNameCtr.setValidators(null);
      paramOtherUnitCtr.setValidators(null);
    }
    paramOtherNameCtr.updateValueAndValidity();
    paramOtherUnitCtr.updateValueAndValidity();
  };
  public showAndHideParamErrorLabel = () => {
    let valid = true;
    if (
      this.paramOther.checked &&
      !AppUtils.hasValueNotEmpty(this.paramOther.name) &&
      AppUtils.hasValueNotEmpty(this.paramOther.unit)
    ) {
      valid = false;
    } else if (this.load.parameters.length > 0) {
      let countUndefined = 0;
      for (let i = 0; i < this.load.parameters.length; i++) {
        if (this.load.parameters[i] === undefined) {
          countUndefined++;
          continue;
        }
        if (
          this.load.parameters[i].name !== Constants.LOAD_PARAM.ALL_ELECTRICAL
        ) {
          if (!AppUtils.hasValueNotEmpty(this.load.parameters[i].unit)) {
            valid = false;
            break;
          }
        }
      }
      if (!this.paramOther.checked && countUndefined === this.params.length) {
        valid = false;
      }
    }
    this.showParamErrorLabel = !valid;
  };
  public generateFlowChannels = (
    type: string,
    noOfItems: number,
    subTypeName: string
  ) => {
    switch (subTypeName) {
      case 'StratificationTank': {
        this.generateFlowStratificationTankChannels(type, noOfItems);
        break;
      }
      case 'Generic': {
        this.generateGenericChannels(type, noOfItems);
        break;
      }
      case 'Hydraulic': {
        this.generateHydraulicChannels(type, noOfItems);
        break;
      }
      default: {
        break;
      }
    }
  };
  private generateGenericChannels = (type: string, noOfItems: number) => {
    const inputNoCtr = this.formMasterGroup.get('inputNoSensorCtr');
    if (noOfItems > 30) {
      inputNoCtr.updateValueAndValidity();
    } else {
      this.load.inlets = [];
      const inletItems = this.formMasterGroup.get(
        'inletSensingItems'
      ) as FormArray;
      inletItems.controls = [];
      for (let i = 0; i < noOfItems; i++) {
        if (
          this.commonService.isNullOrUndefined(this.formData.inlets) ||
          this.formData.inlets.length === 0
        ) {
          this.load.inlets.push(new LoadInletSensingModel());
        } else {
          let inlet = new LoadInletSensingModel();
          inlet = this.formData.inlets[i];
          this.load.inlets.push(inlet);
        }

        inletItems.push(this.createInletsSenssingItems());
      }
      inletItems.updateValueAndValidity();
      if (!this.commonService.isNullOrUndefined(this.formData.inlets)) {
        this.formData.inlets = undefined;
      }
    }
  };
  public onOutTypeChange = (type: string, index: number) => {
    let control: AbstractControl;
    let items: FormArray;
    switch (type) {
      case 'Generic': {
        items = <FormArray>this.formMasterGroup.get('inletSensingItems');
        control = items.controls[index];
        break;
      }
      case 'HydraulicInlet': {
        items = <FormArray>this.formMasterGroup.get('inletHydraulicItems');
        control = items.controls[index];
        break;
      }
      case 'HydraulicOutlet': {
        items = <FormArray>this.formMasterGroup.get('outletHydraulicItems');
        control = items.controls[index];
        break;
      }
      default: {
        break;
      }
    }
    const digitalOutputMappingCtr = control.get('digitalOutputMappingCtr');
    const outputTypeCtr = control.get('outputTypeCtr');
    digitalOutputMappingCtr.setValue(null);
    digitalOutputMappingCtr.updateValueAndValidity();
    if (
      outputTypeCtr !== null &&
      outputTypeCtr.value !== null &&
      outputTypeCtr.value === 'Switch'
    ) {
      digitalOutputMappingCtr.setValidators(this.requiredValidators);
    } else {
      digitalOutputMappingCtr.setValidators(null);
    }
    digitalOutputMappingCtr.updateValueAndValidity();
    items.updateValueAndValidity();
  };
  private generateFlowStratificationTankChannels = (
    type: string,
    noOfItems: number
  ) => {
    const inputNoCtr = this.formMasterGroup.get('inputNoCtr');
    const outputNoCtr = this.formMasterGroup.get('outputNoCtr');
    if (noOfItems > 10) {
      inputNoCtr.updateValueAndValidity();
      outputNoCtr.updateValueAndValidity();
    } else {
      // let model;
      if (type === 'INLETS') {
        this.load.inlets = [];
        // model = this.load.inlets;
        const inletItems = this.formMasterGroup.get('inletItems') as FormArray;
        inletItems.controls = [];
        for (let i = 0; i < noOfItems; i++) {
          if (
            this.commonService.isNullOrUndefined(this.formData.inlets) ||
            this.formData.inlets.length === 0
          ) {
            this.load.inlets.push(
              new LoadInletModel(null, null, null, null, null, null, null, true)
            );
          } else {
            let inlet = new LoadInletModel();
            inlet = this.formData.inlets[i];
            this.load.inlets.push(inlet);
          }
          inletItems.push(this.createInletsItems());
        }
        inletItems.updateValueAndValidity();
      } else {
        this.load.outlets = [];
        // model = this.load.outlets;
        const outletItems = this.formMasterGroup.get(
          'outletItems'
        ) as FormArray;
        outletItems.controls = [];
        for (let i = 0; i < noOfItems; i++) {
          if (
            this.commonService.isNullOrUndefined(this.formData.outlets) ||
            this.formData.outlets.length === 0
          ) {
            this.load.outlets.push(
              new LoadInletModel(null, null, null, null, null, null, null, true)
            );
          } else {
            let outlet = new LoadInletModel();
            outlet = this.formData.outlets[i];
            this.load.outlets.push(outlet);
          }
          outletItems.push(this.createInletsItems());
        }
        outletItems.updateValueAndValidity();
      }
      if (!this.commonService.isNullOrUndefined(this.formData.inlets)) {
        this.formData.inlets = undefined;
      }
      if (!this.commonService.isNullOrUndefined(this.formData.outlets)) {
        this.formData.inlets = undefined;
      }
    }
  };
  private generateHydraulicChannels = (type: string, noOfItems: number) => {
    const inputNoCtr = this.formMasterGroup.get('inputNoHydraulicCtr');
    const outputNoCtr = this.formMasterGroup.get('outputNoHydraulicCtr');
    if (noOfItems > 30) {
      inputNoCtr.updateValueAndValidity();
      outputNoCtr.updateValueAndValidity();
    } else {
      // let model;
      if (type === 'INLETS') {
        this.load.inlets = [];
        // model = this.load.inlets;
        const inletItems = this.formMasterGroup.get(
          'inletHydraulicItems'
        ) as FormArray;
        inletItems.controls = [];
        for (let i = 0; i < noOfItems; i++) {
          if (
            this.commonService.isNullOrUndefined(this.formData.inlets) ||
            this.formData.inlets.length === 0
          ) {
            this.load.inlets.push(new LoadInletSensingModel());
          } else {
            let inlet = new LoadInletSensingModel();
            inlet = this.formData.inlets[i];
            this.load.inlets.push(inlet);
          }
          inletItems.push(this.createInletsHydraulicItems());
        }
        inletItems.updateValueAndValidity();
      } else {
        this.load.outlets = [];
        // model = this.load.outlets;
        const outletItems = this.formMasterGroup.get(
          'outletHydraulicItems'
        ) as FormArray;
        outletItems.controls = [];
        for (let i = 0; i < noOfItems; i++) {
          if (
            this.commonService.isNullOrUndefined(this.formData.outlets) ||
            this.formData.outlets.length === 0
          ) {
            this.load.outlets.push(new LoadInletSensingModel());
          } else {
            let outlet = new LoadInletSensingModel();
            outlet = this.formData.outlets[i];
            this.load.outlets.push(outlet);
          }
          outletItems.push(this.createInletsHydraulicItems());
        }
        outletItems.updateValueAndValidity();
      }
      if (!this.commonService.isNullOrUndefined(this.formData.inlets)) {
        this.formData.inlets = undefined;
      }
      if (!this.commonService.isNullOrUndefined(this.formData.outlets)) {
        this.formData.inlets = undefined;
      }
    }
  };
  public onThermoclinesChange = () => {
    const inputNoCtr = this.formMasterGroup.get('inputNoCtr');
    const thermoclinesCtr = this.formMasterGroup.get('thermoclinesCtr');
    if (
      thermoclinesCtr !== null &&
      inputNoCtr !== null &&
      thermoclinesCtr.value !== null &&
      inputNoCtr.value !== null &&
      thermoclinesCtr.value > inputNoCtr.value
    ) {
      thermoclinesCtr.setValidators(lessThanInletValidator);
    } else {
      thermoclinesCtr.setValidators(null);
      thermoclinesCtr.setValidators(this.requiredValidators);
    }
    thermoclinesCtr.updateValueAndValidity();
  };
  public onHasEnergyMeterChange = (type: string) => {
    if (
      this.load.hasEnergyMeter !== undefined &&
      this.load.hasEnergyMeter !== ''
    ) {
      const machineIDCtr =
        type === 'hydraulicCtr'
          ? this.formMasterGroup.get('machineIDHydraulicCtr')
          : this.formMasterGroup.get('machineIDCtr');
      const meterCtr = this.formMasterGroup.get('meterCtr');
      if (this.load.hasEnergyMeter === 'NO') {
        meterCtr.setValidators(null);
        machineIDCtr.setValidators(this.requiredValidators);
      } else {
        meterCtr.setValidators(this.requiredValidators);
        machineIDCtr.setValidators(null);
      }
      meterCtr.updateValueAndValidity();
      machineIDCtr.updateValueAndValidity();
      this.removeMeterCtr();
      this.setMeterCtr();
    }
  };
  public onDrflexibilityChange = () => {
    if (
      this.tempModel.drflexibility !== undefined &&
      this.tempModel.drflexibility !== ''
    ) {
      const drflexibilityCtr = this.formMasterGroup.get('drflexibilityCtr');
      if (this.tempModel.drflexibility === 'Yes') {
        // const validator = [Validators.required, Validators.minLength(1), Validators.maxLength(3)];
        const validator = [Validators.minLength(1), Validators.maxLength(3)];
        drflexibilityCtr.setValidators(validator);
      } else {
        drflexibilityCtr.setValidators(null);
      }
      drflexibilityCtr.updateValueAndValidity();
    }
  };
  public submit = () => {
    const load = cloneDeep(this.load);
    const parametersTemp = [];
    for (let i = 0; i < load.parameters.length; i++) {
      if (
        load.parameters[i] !== undefined &&
        load.parameters[i].selected === true
      ) {
        const parameter = load.parameters[i];
        if (parameter.value === Constants.LOAD_PARAM.ALL_ELECTRICAL) {
          parameter.unit = '';
        }
        parametersTemp.push({ name: parameter.value, unit: parameter.unit });
      }
    }
    load.parameters = parametersTemp;
    if (this.paramOther.checked) {
      load.parameters.push({
        name: this.paramOther.name,
        unit: this.paramOther.unit,
        other: true
      });
    }
    // let successMsg = '';
    // if ($scope.createNew === false) {
    // 	successMsg = 'Update Load successfully!';
    // } else {
    // 	successMsg = 'New Load is created successfully!';
    // 	load.siteID = $scope.formData.selectedSiteId.toString();
    // 	load.meter = $scope.formData.meter;
    // }
    if (this.kpiUtility == 'Water' && load.parameters.length == 0) {
      load.parameters.push({ name: 'waterParams', unit: '', other: false });
    }
    load.meter = this.formData.meter;
    if (this.load.hasEnergyMeter === 'NO') {
      load.meter = null;
    }
    // $scope.load.outlets = [{}];
    load.siteID = load.siteID;
    if (load.type === 'Generic / Area Specific Sensor') {
      load.type = 'GenericSensorLoad';
    }
    this.siteService.saveLoad(load).subscribe((data) => {
      if (!ObjectUtils.isNullOrUndefined(data.loadId)) {
        if (this.createNew) {
          this.alertService.message = 'New Load is created successfully!';
        } else {
          this.alertService.message = 'Update Load is successfully!';
        }

        this.alertService.showSuccess();
        this.formDirective.resetForm();
        this.formMasterGroup.reset();

        this.isSiteSelected = false;
        this.isDuplicatedLoadName = false;
        this.isDuplicatedMachineId = false;
        // Uncheck all params
        this.paramsAll = false;
        this.paramOther.checked = false;
        this.checkAllParams();
      } else {
        this.alertService.message = 'Fail on create new Load!';
        this.alertService.showError();
      }
    });
  };
  public reset = (event: any) => {
    event.preventDefault();
    // this.model = new
    this.formDirective.resetForm();
    this.formMasterGroup.reset();
    this.paramsAll = false;
    this.paramOther.checked = false;
    this.checkAllParams();
  };
  // public invalidControl = (event: any) => {
  //   event.preventDefault();
  //   const invalid = [];
  //   const controls = this.formMasterGroup.controls;
  //   for (const name in controls) {
  //     if (controls[name].invalid) {
  //         invalid.push(name);
  //     }
  // }
  //   console.log('Invalid Conteol ---' + invalid);
  // }
  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.formMasterGroup.get(fieldName).hasError(errorCode);
  };
  public isFieldHasErrorinSensing = (
    fieldName: string,
    index: number,
    errorCode: string,
    type: string = 'inlet'
  ): boolean => {
    let control: AbstractControl;
    switch (type) {
      case 'inlet': {
        control = (<FormArray>this.formMasterGroup.get('inletSensingItems'))
          .controls[index];
        break;
      }
      case 'outlet': {
        control = (<FormArray>this.formMasterGroup.get('outletSensingItems'))
          .controls[index];
        break;
      }
      default: {
        break;
      }
    }
    if (control !== null && control !== undefined) {
      const temp = control.get(fieldName);
      if (temp !== null && temp !== undefined) {
        return temp.hasError(errorCode);
      }
    }
    return false;
  };
  public isFieldHasErrorinHydraulic = (
    fieldName: string,
    index: number,
    errorCode: string,
    type: string = 'inlet'
  ): boolean => {
    let control: AbstractControl;
    switch (type) {
      case 'inlet': {
        control = (<FormArray>this.formMasterGroup.get('inletHydraulicItems'))
          .controls[index];
        break;
      }
      case 'outlet': {
        control = (<FormArray>this.formMasterGroup.get('outletHydraulicItems'))
          .controls[index];
        break;
      }
      default: {
        break;
      }
    }
    if (control !== null && control !== undefined) {
      const temp = control.get(fieldName);
      if (temp !== null && temp !== undefined) {
        return temp.hasError(errorCode);
      }
    }
    return false;
  };
  public isFieldHasErrorinArray = (
    fieldName: string,
    index: number,
    errorCode: string,
    type: string = 'inlet'
  ): boolean => {
    let control: AbstractControl;
    switch (type) {
      case 'inlet': {
        control = (<FormArray>this.formMasterGroup.get('inletItems')).controls[
          index
        ];
        break;
      }
      case 'outlet': {
        control = (<FormArray>this.formMasterGroup.get('outletItems')).controls[
          index
        ];
        break;
      }
      default: {
        break;
      }
    }
    if (control !== null && control !== undefined) {
      const temp = control.get(fieldName);
      if (temp !== null && temp !== undefined) {
        return temp.hasError(errorCode);
      }
    }
    return false;
  };
  // Sensor Change
  public onInputNameSensorChange = (index: number, type: string) => {
    let control: AbstractControl;
    let tempValidateFn: ValidatorFn;
    switch (type) {
      case 'inlet': {
        control = (<FormArray>this.formMasterGroup.get('inletSensingItems'))
          .controls[index];
        tempValidateFn = inputInletNameUniqueValidator;
        break;
      }
      case 'outlet': {
        control = (<FormArray>this.formMasterGroup.get('outletSensingItems'))
          .controls[index];
        tempValidateFn = inputOutletNameUniqueValidator;
        break;
      }
      default: {
        break;
      }
    }
    const inputNameCtr = control.get('inputNameCtr');
    if (
      inputNameCtr !== null &&
      inputNameCtr.value !== null &&
      inputNameCtr.value.length > 0
    ) {
      inputNameCtr.setValue(inputNameCtr.value.trim());
      inputNameCtr.updateValueAndValidity();
      if (this.isUniqueName(inputNameCtr.value)) {
        inputNameCtr.setValidators(tempValidateFn);
      } else {
        const validator = [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(15)
        ];
        inputNameCtr.setValidators(null);
        inputNameCtr.setValidators(validator);
      }
      inputNameCtr.updateValueAndValidity();
    }
  };
  public onFlowChannelIDSensorChange = (index: number, type: string) => {
    let control: AbstractControl;
    let tempValidateFn: ValidatorFn;
    switch (type) {
      case 'inlet': {
        control = (<FormArray>this.formMasterGroup.get('inletSensingItems'))
          .controls[index];
        tempValidateFn = inputInletIDUniqueValidator;
        break;
      }
      case 'outlet': {
        control = (<FormArray>this.formMasterGroup.get('outletSensingItems'))
          .controls[index];
        tempValidateFn = inputOutletIDUniqueValidator;
        break;
      }
      default: {
        break;
      }
    }
    const inputNameCtr = control.get('inputIDCtr');
    if (
      inputNameCtr !== null &&
      inputNameCtr.value !== null &&
      inputNameCtr.value.length > 0
    ) {
      inputNameCtr.setValue(inputNameCtr.value.trim());
      inputNameCtr.updateValueAndValidity();
      if (this.isUniqueID(inputNameCtr.value)) {
        inputNameCtr.setValidators(tempValidateFn);
      } else {
        const validator = [Validators.required];
        inputNameCtr.setValidators(null);
        inputNameCtr.setValidators(validator);
      }
      inputNameCtr.updateValueAndValidity();
    }
  };
  public onLowerThresholdSensorChange = (index: number, type: string) => {
    let control: AbstractControl;
    let tempValidateFn: ValidatorFn;
    switch (type) {
      case 'inlet': {
        control = (<FormArray>this.formMasterGroup.get('inletSensingItems'))
          .controls[index];
        tempValidateFn = isInletLowerThresholdValid;
        break;
      }
      case 'outlet': {
        control = (<FormArray>this.formMasterGroup.get('outletSensingItems'))
          .controls[index];
        tempValidateFn = isOutletLowerThresholdValid;
        break;
      }
      default: {
        break;
      }
    }
    if (control !== null && control !== undefined) {
      const lower = control.get('inletThresholdTempCtr');
      const upper = control.get('inletUpperThresholdTempCtr');
      if (
        lower !== null &&
        upper !== null &&
        lower.value !== null &&
        upper.value !== null &&
        lower.value > upper.value
      ) {
        lower.setValidators(tempValidateFn);
      } else {
        lower.setValidators(null);
        lower.setValidators(this.requiredValidators);
      }
      lower.updateValueAndValidity();
    }
  };
  public onUpperThresholdSensorChange = (index: number, type: string) => {
    let control: AbstractControl;
    let tempValidateFn: ValidatorFn;
    switch (type) {
      case 'inlet': {
        control = (<FormArray>this.formMasterGroup.get('inletSensingItems'))
          .controls[index];
        tempValidateFn = isInletUpperThresholdValid;
        break;
      }
      case 'outlet': {
        control = (<FormArray>this.formMasterGroup.get('outletSensingItems'))
          .controls[index];
        tempValidateFn = isOutLetUpperThresholdValid;
        break;
      }
      default: {
        break;
      }
    }
    if (control !== null && control !== undefined) {
      const lower = control.get('inletThresholdTempCtr');
      const upper = control.get('inletUpperThresholdTempCtr');
      if (
        lower !== null &&
        upper !== null &&
        lower.value !== null &&
        upper.value !== null &&
        upper.value < lower.value
      ) {
        upper.setValidators(tempValidateFn);
      } else {
        upper.setValidators(null);
        upper.setValidators(this.requiredValidators);
      }
      upper.updateValueAndValidity();
    }
  };
  // Hydraulic Change
  public onInputNameHydraulicChange = (index: number, type: string) => {
    let control: AbstractControl;
    let tempValidateFn: ValidatorFn;
    switch (type) {
      case 'inlet': {
        control = (<FormArray>this.formMasterGroup.get('inletHydraulicItems'))
          .controls[index];
        tempValidateFn = inputInletNameUniqueValidator;
        break;
      }
      case 'outlet': {
        control = (<FormArray>this.formMasterGroup.get('outletHydraulicItems'))
          .controls[index];
        tempValidateFn = inputOutletNameUniqueValidator;
        break;
      }
      default: {
        break;
      }
    }
    const inputNameCtr = control.get('inputNameCtr');
    if (
      inputNameCtr !== null &&
      inputNameCtr.value !== null &&
      inputNameCtr.value.length > 0
    ) {
      inputNameCtr.setValue(inputNameCtr.value.trim());
      inputNameCtr.updateValueAndValidity();
      if (this.isUniqueName(inputNameCtr.value)) {
        inputNameCtr.setValidators(tempValidateFn);
      } else {
        const validator = [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(15)
        ];
        inputNameCtr.setValidators(null);
        inputNameCtr.setValidators(validator);
      }
      inputNameCtr.updateValueAndValidity();
    }
  };
  public onFlowChannelIDHydraulicChange = (index: number, type: string) => {
    let control: AbstractControl;
    let tempValidateFn: ValidatorFn;
    switch (type) {
      case 'inlet': {
        control = (<FormArray>this.formMasterGroup.get('inletHydraulicItems'))
          .controls[index];
        tempValidateFn = inputInletIDUniqueValidator;
        break;
      }
      case 'outlet': {
        control = (<FormArray>this.formMasterGroup.get('outletHydraulicItems'))
          .controls[index];
        tempValidateFn = inputOutletIDUniqueValidator;
        break;
      }
      default: {
        break;
      }
    }
    const inputNameCtr = control.get('inputIDCtr');
    if (
      inputNameCtr !== null &&
      inputNameCtr.value !== null &&
      inputNameCtr.value.length > 0
    ) {
      inputNameCtr.setValue(inputNameCtr.value.trim());
      inputNameCtr.updateValueAndValidity();
      if (this.isUniqueID(inputNameCtr.value)) {
        inputNameCtr.setValidators(tempValidateFn);
      } else {
        const validator = [Validators.required];
        inputNameCtr.setValidators(null);
        inputNameCtr.setValidators(validator);
      }
      inputNameCtr.updateValueAndValidity();
    }
  };
  // StratificationTank Change
  public onInputNameStratificationTankChange = (
    index: number,
    type: string
  ) => {
    let control: AbstractControl;
    let tempValidateFn: ValidatorFn;
    switch (type) {
      case 'inlet': {
        control = (<FormArray>this.formMasterGroup.get('inletItems')).controls[
          index
        ];
        tempValidateFn = inputInletNameUniqueValidator;
        break;
      }
      case 'outlet': {
        control = (<FormArray>this.formMasterGroup.get('outletItems')).controls[
          index
        ];
        tempValidateFn = inputOutletNameUniqueValidator;
        break;
      }
      default: {
        break;
      }
    }
    const inputNameCtr = control.get('inputNameCtr');
    if (
      inputNameCtr !== null &&
      inputNameCtr.value !== null &&
      inputNameCtr.value.length > 0
    ) {
      inputNameCtr.setValue(inputNameCtr.value.trim());
      inputNameCtr.updateValueAndValidity();
      if (this.isUniqueName(inputNameCtr.value)) {
        inputNameCtr.setValidators(tempValidateFn);
      } else {
        const validator = [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(15)
        ];
        inputNameCtr.setValidators(null);
        inputNameCtr.setValidators(validator);
      }
      inputNameCtr.updateValueAndValidity();
    }
  };

  public onFlowChannelIDChange = (index: number, type: string) => {
    let control: AbstractControl;
    let tempValidateFn: ValidatorFn;
    switch (type) {
      case 'inlet': {
        control = (<FormArray>this.formMasterGroup.get('inletItems')).controls[
          index
        ];
        tempValidateFn = inputInletIDUniqueValidator;
        break;
      }
      case 'outlet': {
        control = (<FormArray>this.formMasterGroup.get('outletItems')).controls[
          index
        ];
        tempValidateFn = inputOutletIDUniqueValidator;
        break;
      }
      default: {
        break;
      }
    }
    const inputNameCtr = control.get('inputIDCtr');
    if (
      inputNameCtr !== null &&
      inputNameCtr.value !== null &&
      inputNameCtr.value.length > 0
    ) {
      inputNameCtr.setValue(inputNameCtr.value.trim());
      inputNameCtr.updateValueAndValidity();
      if (this.isUniqueID(inputNameCtr.value)) {
        inputNameCtr.setValidators(tempValidateFn);
      } else {
        const validator = [Validators.required];
        inputNameCtr.setValidators(null);
        inputNameCtr.setValidators(validator);
      }
      inputNameCtr.updateValueAndValidity();
    }
  };
  private isUniqueName = (value: string): boolean => {
    let inlets = [];
    let oulets = [];
    if (this.load.inlets !== undefined) {
      inlets = cloneDeep(this.load.inlets);
    }
    if (this.load.outlets !== undefined) {
      oulets = cloneDeep(this.load.outlets);
    }
    return (
      inlets.concat(oulets).filter((x) => x.name === value.trim()).length > 1
    );
  };
  private isUniqueID = (value: string): boolean => {
    let inlets = [];
    let oulets = [];
    if (this.load.inlets !== undefined) {
      inlets = cloneDeep(this.load.inlets);
    }
    if (this.load.outlets !== undefined) {
      oulets = cloneDeep(this.load.outlets);
    }
    return (
      inlets.concat(oulets).filter((x) => x.flowChannelID === value.trim())
        .length > 1
    );
  };
  public onLowerThresholdTemperatureChange = (index: number, type: string) => {
    let control: AbstractControl;
    let tempValidateFn: ValidatorFn;
    switch (type) {
      case 'inlet': {
        control = (<FormArray>this.formMasterGroup.get('inletItems')).controls[
          index
        ];
        tempValidateFn = isInletLowerThresholdValid;
        break;
      }
      case 'outlet': {
        control = (<FormArray>this.formMasterGroup.get('outletItems')).controls[
          index
        ];
        tempValidateFn = isOutletLowerThresholdValid;
        break;
      }
      default: {
        break;
      }
    }
    if (control !== null && control !== undefined) {
      const lower = control.get('inletThresholdTempCtr');
      const upper = control.get('inletUpperThresholdTempCtr');
      if (
        lower !== null &&
        upper !== null &&
        lower.value !== null &&
        upper.value !== null &&
        lower.value > upper.value
      ) {
        lower.setValidators(tempValidateFn);
      } else {
        lower.setValidators(null);
        lower.setValidators(this.requiredValidators);
      }
      lower.updateValueAndValidity();
    }
  };
  public onUpperThresholdTemperatureChange = (index: number, type: string) => {
    let control: AbstractControl;
    let tempValidateFn: ValidatorFn;
    switch (type) {
      case 'inlet': {
        control = (<FormArray>this.formMasterGroup.get('inletItems')).controls[
          index
        ];
        tempValidateFn = isInletUpperThresholdValid;
        break;
      }
      case 'outlet': {
        control = (<FormArray>this.formMasterGroup.get('outletItems')).controls[
          index
        ];
        tempValidateFn = isOutLetUpperThresholdValid;
        break;
      }
      default: {
        break;
      }
    }
    if (control !== null && control !== undefined) {
      const lower = control.get('inletThresholdTempCtr');
      const upper = control.get('inletUpperThresholdTempCtr');
      if (
        lower !== null &&
        upper !== null &&
        lower.value !== null &&
        upper.value !== null &&
        upper.value < lower.value
      ) {
        upper.setValidators(tempValidateFn);
      } else {
        upper.setValidators(null);
        upper.setValidators(this.requiredValidators);
      }
      upper.updateValueAndValidity();
    }
  };
  public onLowerThresholdHydraulicChange = (index: number, type: string) => {
    let control: AbstractControl;
    let tempValidateFn: ValidatorFn;
    switch (type) {
      case 'inlet': {
        control = (<FormArray>this.formMasterGroup.get('inletHydraulicItems'))
          .controls[index];
        tempValidateFn = isInletLowerThresholdValid;
        break;
      }
      case 'outlet': {
        control = (<FormArray>this.formMasterGroup.get('outletHydraulicItems'))
          .controls[index];
        tempValidateFn = isOutletLowerThresholdValid;
        break;
      }
      default: {
        break;
      }
    }
    if (control !== null && control !== undefined) {
      const lower = control.get('inletThresholdTempCtr');
      const upper = control.get('inletUpperThresholdTempCtr');
      if (
        lower !== null &&
        upper !== null &&
        lower.value !== null &&
        upper.value !== null &&
        lower.value > upper.value
      ) {
        lower.setValidators(tempValidateFn);
      } else {
        lower.setValidators(null);
        lower.setValidators(this.requiredValidators);
      }
      lower.updateValueAndValidity();
    }
  };
  public onUpperThresholdHydraulicChange = (index: number, type: string) => {
    let control: AbstractControl;
    let tempValidateFn: ValidatorFn;
    switch (type) {
      case 'inlet': {
        control = (<FormArray>this.formMasterGroup.get('inletHydraulicItems'))
          .controls[index];
        tempValidateFn = isInletUpperThresholdValid;
        break;
      }
      case 'outlet': {
        control = (<FormArray>this.formMasterGroup.get('outletHydraulicItems'))
          .controls[index];
        tempValidateFn = isOutLetUpperThresholdValid;
        break;
      }
      default: {
        break;
      }
    }
    if (control !== null && control !== undefined) {
      const lower = control.get('inletThresholdTempCtr');
      const upper = control.get('inletUpperThresholdTempCtr');
      if (
        lower !== null &&
        upper !== null &&
        lower.value !== null &&
        upper.value !== null &&
        upper.value < lower.value
      ) {
        upper.setValidators(tempValidateFn);
      } else {
        upper.setValidators(null);
        upper.setValidators(this.requiredValidators);
      }
      upper.updateValueAndValidity();
    }
  };

  checkDuplicatedLoadName() {
    if (this.createNew === false) {
      return;
    }
    this.isDuplicatedLoadName =
      this.load.name && this.load.name.length > 0
        ? this.availableLoadName.includes(this.load.name.toLowerCase())
        : false;
    if (this.isDuplicatedLoadName) {
      this.formMasterGroup.get('loadNameCtr').setErrors({ duplicated: true });
    } else {
      const error = this.formMasterGroup
        .get('loadNameCtr')
        .getError('duplicated');
      if (error) {
        this.formMasterGroup.get('loadNameCtr').setErrors(null);
      }
    }
  }

  checkDuplicatedMachineId() {
    if (
      (this.load.type === 'Generic / Area Specific Sensor' ||
        (this.load.subType === 'Generic Load' &&
          this.load.type === 'Turning')) &&
      this.load.hasEnergyMeter === 'NO'
    ) {
      let tempMachineID = this.load.machineID + '';
      this.isDuplicatedMachineId =
        tempMachineID && tempMachineID.length > 0
          ? this.availableMachineId.includes(tempMachineID.toLowerCase())
          : false;
      if (this.isDuplicatedMachineId) {
        this.formMasterGroup
          .get('machineIDCtr')
          .setErrors({ duplicated: true });
      } else {
        const error = this.formMasterGroup
          .get('machineIDCtr')
          .getError('duplicated');
        if (error) {
          this.formMasterGroup.get('machineIDCtr').setErrors(null);
        }
      }
    }
  }

  public onSiteChange = () => {
    if (
      !this.commonService.isNullOrUndefined(this.load.siteID) &&
      this.load.siteID !== ''
    ) {
      this.isSiteSelected = true;
      this.availableLoadName = [];
      this.availableMachineId = [];
      this.params = [
        {
          value: Constants.LOAD_PARAM.ALL_ELECTRICAL,
          text: 'All Electrical Parameters'
        },
        {
          value: Constants.LOAD_PARAM.ALL_HARMONIC,
          text: 'All Harmonic Parameters'
        },
        { value: Constants.LOAD_PARAM.ALL_WATER, text: 'All Water Parameters' },
        { value: Constants.LOAD_PARAM.TEMPERATURE, text: 'Temperature' },
        { value: Constants.LOAD_PARAM.PRESSURE, text: 'Pressure' },
        { value: Constants.LOAD_PARAM.FLOW_OUTPUT, text: 'Flow Output' }
      ];
      this.load.parameters = this.params.map(
        (x) => new LoadParameterModel(x.text, x.value, '', false)
      );
      this.plantService.getSiteDetail(this.load.siteID).subscribe((data) => {
        if (!this.commonService.isNullOrUndefined(data)) {
          this.configuredKpiUtilities = data.configuredKpiUtilities;
        }
      });

      this.siteService.getLoadsBySiteId(this.load.siteID).subscribe((data) => {
        if (!ObjectUtils.isNullOrUndefined(data)) {
          data.forEach((element) => {
            if (!ObjectUtils.isNullOrUndefined(element.name)) {
              this.availableLoadName.push(element.name.toLowerCase());
            }
            if (!ObjectUtils.isNullOrUndefined(element.machineID)) {
              this.availableMachineId.push(element.machineID.toLowerCase());
            }
          });
          this.checkDuplicatedLoadName();
          this.checkDuplicatedMachineId();
        } else {
          this.isSiteSelected = false;
          this.availableLoadName = [];
          this.availableMachineId = [];
        }
      });
    }
  };

  /**
   * Function to trigger on selection of kpiUtility and fetching Load type
   *
   * @param {*} event
   * @memberof AddLoadComponent
   */
  onUtilityChange(event) {
    if (event) {
      this.kpiUtility = event;
      this.loadTypes = [];
      console.log('onUtilityChange', event, this.kpiUtility);

      this.siteService
        .getUnassignedMetersOfRole(this.load.siteID, 'Load', this.kpiUtility)
        .subscribe((data) => {
          if (!this.commonService.isNullOrUndefined(data)) {
            this.availableMeters = data;
          }
        });
      this.hydraulicOutputType = [];
      const tempType = Object.keys(Constants.HYDRAULIC_OUTPUT_TYPE);
      for (let i = 0; i < tempType.length; i++) {
        const temp = Constants.HYDRAULIC_OUTPUT_TYPE[tempType[i]];
        this.hydraulicOutputType.push({ value: tempType[i], text: temp });
      }

      if (this.kpiUtility == 'Energy') {
        this.consLoadTypeObj = Constants.LOAD_TYPE;
        this.consLoadTypeKeys = Object.keys(this.consLoadTypeObj);
        for (let i = 0; i < this.consLoadTypeKeys.length; i++) {
          const temp =
            this.consLoadTypeObj[this.consLoadTypeKeys[i]]['TYPE_VALUE'];
          if (temp === 'GenericSensorLoad') {
            this.loadTypes.push('Generic / Area Specific Sensor');
          } else {
            this.loadTypes.push(temp);
          }
        }
      } else {
        this.siteService
          .getAllLoadTypesForkpiUtility(this.kpiUtility)
          .subscribe((data) => {
            this.loadTypes = data.LoadTypes;
          });
        if (this.kpiUtility == 'Water') {
          this.formMasterGroup.get('subTypeCtr').setValue(null);
          this.formMasterGroup.get('subTypeCtr').setValidators(null);
          this.formMasterGroup.get('subTypeCtr').updateValueAndValidity();
          this.formMasterGroup.get('phasetypeCtr').setValue(null);
          this.formMasterGroup.get('phasetypeCtr').setValidators(null);
          this.formMasterGroup.get('phasetypeCtr').updateValueAndValidity();
          //this.formMasterGroup.get('phasetypeCtr').disable();
          //this.formMasterGroup.get('subTypeCtr').disable();
        }
        if (this.kpiUtility == 'Gas') {
          this.formMasterGroup.get('subTypeCtr').setValue(null);
          this.formMasterGroup.get('subTypeCtr').setValidators(null);
          this.formMasterGroup.get('subTypeCtr').updateValueAndValidity();
          this.formMasterGroup.get('phasetypeCtr').setValue(null);
          this.formMasterGroup.get('phasetypeCtr').setValidators(null);
          this.formMasterGroup.get('phasetypeCtr').updateValueAndValidity();
        }
      }
    }
  }
}
